import { useEffect } from 'react'
import PropTypes from 'prop-types'

export default function EscToClose ({ onEsc }) {
  useEffect(() => {
    const handleEsc = event => {
      if (event.keyCode === 27) {
        onEsc()
      }
    }
    window.addEventListener('keydown', handleEsc)
    return () => {
      window.removeEventListener('keydown', handleEsc)
    }
  }, [onEsc])

  return null
}

EscToClose.propTypes = {
  onEsc: PropTypes.func
}
